const filenameData = (filename) => {
  const lastDot = filename.lastIndexOf('.')
  const basename = filename.substring(0, lastDot + 1)
  const extension = filename.substring(lastDot + 1, filename.length)

  return {
    extension,
    basename,
  }
}

export default filenameData
